import React from 'react';

import clientRouters from './clientRoutes';
import robotRouters from './robotRoutes';
import therapistRouters from './therapistRoutes';
import otherRoutes from './otherRoutes';
import diyDollRouters from './diyDollRouters';
import adminRoutes from './adminRoutes';
import safetyRoutes from './safetyRoutes';
import preEmploymentRouters from './preEmploymentRouters';
import courseActivityRoutes from './courseActivityRoutes';
import tarotRoutes from './tarotRoutes';

const routers = [
  ...adminRoutes,
  ...clientRouters,
  ...robotRouters,
  ...therapistRouters,
  ...otherRoutes,
  ...diyDollRouters,
  ...safetyRoutes,
  ...preEmploymentRouters,
  ...courseActivityRoutes,
  ...tarotRoutes,
];

export default routers